import { HouseSubscriptionContainer } from '../HouseSubscriptionContainer';
import { ManagementCompanyContainer } from '../ManagementCompanyContainer';
import { MarketTrendsContainer } from '../MarketTrendsContainer';
import { HeadContainer } from '../HeadContainer';

import { PageLayout } from 'shared/components/PageLayout';
import { AdaptiveContainer } from '../AdaptiveContainer';
import { InfrastructureMapMicrofrontend } from '../InfrastructureMapMicrofrontend';
import { InfrastructureSectionWrapper } from '../InfrastructureSectionContainer';
import { OffersHistoryDesktopContainer, OffersHistoryMobileContainer } from '../OffersHistoryContainer';
import { OffersListContainer } from '../OffersListContainer';
import { MyHouseBannerContainer } from '../MyHouseBannerContainer';
import { SeoMarkedListContainer } from '../SeoMarkedListContainer';

export const PageContainer = () => {
  return (
    <PageLayout>
      {/** Шапка страницы */}
      <HeadContainer />
      {/** Блок инфраструктуры с картой */}
      <AdaptiveContainer desktop={InfrastructureMapMicrofrontend} mobile={InfrastructureSectionWrapper} />
      {/** Блок трендов с графиками и динамикой */}
      <MarketTrendsContainer />
      {/** Баннер с ссылкой на оценку дома */}
      <MyHouseBannerContainer />
      {/** Блок с объявлениями в доме */}
      <OffersListContainer />
      {/** Баннер подписки на дом */}
      <HouseSubscriptionContainer />
      {/** Блок с историей объявлений в доме */}
      <AdaptiveContainer desktop={OffersHistoryDesktopContainer} mobile={OffersHistoryMobileContainer} />
      {/** Блок с управляющей компанией */}
      <ManagementCompanyContainer />
      {/** Маркированный список SEO */}
      <SeoMarkedListContainer />
    </PageLayout>
  );
};
